'use client';

import { CSSProperties } from 'react';

import { ListWrapper } from './ListStyle';

export interface ListProps<T> {
  dataSource: T[];
  renderItem?: (item: T, index: number) => React.ReactNode;
  style?: CSSProperties;
  className?: string;
}

const List = <T,>({
  dataSource,
  renderItem,
  style,
  className,
}: ListProps<T>) => {
  return (
    <ListWrapper style={style} className={className}>
      {dataSource?.map((item, index) => renderItem?.(item, index))}
    </ListWrapper>
  );
};

export default List;
